// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
// import MediaPlayer from 'components/MediaPlayer/MediaPlayer'
import Editable from 'components/Editable/Editable'
import Logo from 'components/svg/logo/pathfinder-logo.svg'

class Home extends React.Component {
	constructor() {
		super()
	}

	renderVideo = () => {
		// return null

		return (
			<div className="-video" dangerouslySetInnerHTML={ { __html: `
				<video src="${siteData.videos_url}2023-02-720.mp4" preload="auto" autoPlay="autoplay" loop muted playsinline></video>
			` } } />
		)
	}

	render() {
		const { page } = this.props

		return (
			<div className="section-home">
				<div className="-inner">
					<div className="-logo">
						<Logo />
					</div>

					<div className="-links">
						<Link to="/join" className="-join">
							<span>
								<span>Join</span>
							</span>
						</Link>
						<Link to="/explore" className="-explore">
							<span>
								<span>Explore</span>
							</span>
						</Link>
						<Link to="/staff" className="-staff">
							<span>
								<span>Staff</span>
							</span>
						</Link>
					</div>

					{ this.renderVideo() }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( Home )



// WEBPACK FOOTER //
// ./views/pages/Home.jsx